<template>
  <div>
    <div v-if="mode == 'VIEW'">
      <div class="question-container">
        <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
        <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
      </div>
      <br />
      <div class="activity_add_edit_index col-md-12 clearfix pl-0">
        <div class="row">
          <div class="form-group col-md-2 p-0 rows_label_div">
            <label>Rows</label>
            <div v-for="(rowName, i) in question.rows" :key="i + '_row'">
              <input readonly :value="stripHtml(question.rows[i])" class="form-control" placeholder="Enter label" />
            </div>
          </div>
          <div class="form-group col-md-10 p-0 rows_label_div">
            <div class="row">
              <div class="col-md-2 p-0" v-for="(colName, i) in question.cols" :key="i + '_col'">
                <label>Columns</label>
                <input readonly class="form-control" :value="stripHtml(question.cols[i])" placeholder="Enter label" />
                <div v-for="(rowName, j) in question.rows" :key="j + '_row'">
                  <div v-if="question.indexValues[j][i]">
                    <input readonly @click="selectIndexCell(j, i)" :value="stripHtml(question.indexValues[j][i].value)" class="form-control" placeholder="Enter value" />
                  </div>
                  <div v-else>
                    <input readonly @click="selectIndexCell(j, i)" value="" class="form-control" placeholder="Enter value" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="mode == 'EDIT'">
      <div class="p-0 pb-10 clearfix">
        <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
          <span
            class="add-help-text top-positon"
            :class="{
              'right-position': activityDetails.customParticipantMessaging
            }"
            :style="{
              color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Help
          </span>
        </div>
        <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
          <span
            class="add-help-text"
            :style="{
              color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Message
          </span>
        </div>
        <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
      </div>

      <!-- help content -->
      <div v-if="isAddHelpEnabled">
        <h5 class="answer">Help</h5>
        <quill-editor class="bg-white mt-40" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
      </div>

      <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
        <div class="col-md-11 p-0">
          <h5 class="mt-10">Message</h5>
          <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
        </div>
        <div class="col-md-1 p-0">
          <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
            <img src="static/img/delete.svg" />
          </button>
        </div>
      </div>

      <div class="activity_add_edit_index clearfix">
        <div class="">
          <div class="form-group col-md-2 p-0 rows_label_div">
            <label>Rows</label>
            <div v-for="(rowName, i) in numRows" :key="i + '_row'">
              <div class="row_input">
                <input :value="stripHtml(question.rows[i])" :title="stripHtml(question.rows[i])" class="form-control text-truncate" placeholder="Enter label" @click="selectIndexCell(i, 'r')" />
                <button class="btn btn-link color_red p-0" v-on:click="deleteRow(i)" v-if="i != 0">
                  <img class="mt-6 mr-1 p-0" src="static/img/delete.svg" />
                </button>
              </div>
              <div v-show="isActiveIndexCell(i, 'r')" class="modal-content">
                <label class="color_666669">Header label</label>
                <quill-editor ref="indexRowLabel" class="instruction-screen bg-white mb-15" v-model="question.rows[i]" :options="commonProps.editorOptionForLabel"></quill-editor>
                <div class="text-right mb-20">
                  <div @click="selectIndexCell(-1, -1)" class="btn btn-success save_btn br-25">
                    Save
                  </div>
                </div>
              </div>
            </div>
            <a href="javascript:void(0);" class="add_row mt-12" @click="addRowIndex()">Add another row</a>
          </div>
          <div class="form-group col-md-10 p-0 rows_label_div">
            <div>
              <div class="col-md-2 p-0" v-for="(colName, i) in numCols" :key="i + '_col'">
                <label>Columns</label>
                <div class="column_input">
                  <input class="form-control text-truncate" :value="stripHtml(question.cols[i])" :title="stripHtml(question.cols[i])" placeholder="Enter label" @click="selectIndexCell(i, 'c')" />
                  <button class="btn btn-link color_red p-0" v-on:click="deleteCol(i)" v-if="i != 0">
                    <img class="mt-6 mr-1 p-0" src="static/img/delete.svg" />
                  </button>
                </div>
                <div v-show="isActiveIndexCell(i, 'c')" class="modal-content">
                  <label class="color_666669">Header label</label>
                  <quill-editor ref="indexColumnLabel" class="instruction-screen bg-white mb-15" v-model="question.cols[i]" :options="commonProps.editorOptionForLabel"> </quill-editor>
                  <div class="text-right mb-20">
                    <div @click="selectIndexCell(-1, -1)" class="btn btn-success save_btn br-25">
                      Save
                    </div>
                  </div>
                </div>
                <div class="filed_value_box" v-for="(rowName, j) in numRows" :key="j + '_row'">
                  <input @click="selectIndexCell(j, i)" :value="stripHtml(question.indexValues[j][i].value)" :title="stripHtml(question.indexValues[j][i].value)" class="form-control text-truncate" placeholder="Enter value" />
                  <div v-if="question.indexValues[j][i]">
                    <div v-show="isActiveIndexCell(j, i)" class="modal-content">
                      <div class="row">
                        <div class="col-md-10 p-0">
                          <label class="color_666669">Field value</label>
                          <quill-editor :ref="'indexValueLabelcol' + i" class="instruction-screen bg-white mb-15" v-model="question.indexValues[j][i].value" :options="commonProps.editorOptionForValue"> </quill-editor>
                        </div>
                        <div class="col-lg-1 p-0 score_cls" v-show="isActiveIndexCell(j, i)">
                          <h5 class="score_text">Score</h5>
                          <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && question.canScoreResponses == false" formName="score" class="score_input" v-model.number="question.indexValues[j][i].score">
                            <input value="999" v-model.number="question.indexValues[j][i].score" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" type="number" class="integer-plus-minus-input" />
                          </integer-plusminus>
                        </div>
                        <div v-show="isActiveIndexCell(j, i)" class="col-md-12 pr-0 text-right mt-10 mb-15">
                          <div @click="selectIndexCell(-1, -1)" class="btn btn-success save_btn br-25">
                            Save
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-40">
              <a href="javascript:void(0);" @click="addColumnIndex()">Add another column</a>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "IndexStep",
  mixins: [activityStepCustomMessage],
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    commonProps: {},
    activityDetails: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    IntegerPlusminus,
    quillEditor
  },
  data() {
    return {
      activeIndexCellX: "",
      activeIndexCellY: "",
      numRows: 1,
      numCols: 1,
      isAddHelpEnabled: false
    };
  },
  created() {
    if (this.mode == "EDIT" && !this.question.id) {
      this.$set(this.question, "indexValues", [[{ value: "", score: 0 }]]);
      this.question.cols = [""];
      this.question.rows = [""];
    }
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    if (this.mode == "VIEW") {
      this.$set(this.question, "indexValues", this.question.indexValues);
      this.$set(this.question, "cols", this.question.cols);
      this.$set(this.question, "rows", this.question.rows);
    } else {
      this.numRows = this.question.rows.length;
      this.numCols = this.question.cols.length;
    }
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    deleteRow(index) {
      this.question.indexValues.splice(index, 1);
      this.question.rows.splice(index, 1);
      this.numRows = this.numRows - 1;
      this.activeIndexCellX = "";
      this.activeIndexCellY = "";
    },
    deleteCol(index) {
      for (let i = 0; i < this.numRows; i++) {
        this.question.indexValues[i].splice(index, 1);
      }
      this.question.cols.splice(index, 1);
      this.numCols = this.numCols - 1;
      this.activeIndexCellX = "";
      this.activeIndexCellY = "";
    },
    isActiveIndexCell(val1, val2) {
      if (this.activeIndexCellX === val1 && this.activeIndexCellY === val2) {
        return true;
      } else {
        return false;
      }
    },
    selectIndexCell(val1, val2) {
      this.activeIndexCellX = val1;
      this.activeIndexCellY = val2;
      if (val2 == "r") {
        setTimeout(() => {
          this.$refs.indexRowLabel[val1].quill.focus();
        }, 600);
      } else if (val2 == "c") {
        setTimeout(() => {
          this.$refs.indexColumnLabel[val1].quill.focus();
        }, 500);
      } else if (val1 == -1 || val2 == -1) {
        // do nothing
      } else {
        const colref = "indexValueLabelcol" + val2;
        setTimeout(() => {
          const myref = this.$refs[colref];
          myref[val1].quill.focus();
        }, 600);
      }
    },
    addRowIndex() {
      const myArray = [];
      for (let i = 0; i < this.numCols; i++) {
        myArray.push({ value: "", score: 0 });
      }
      this.question.indexValues.push(myArray);
      this.numRows = this.numRows + 1;
      this.question.rows.push("");
    },
    addColumnIndex() {
      for (let i = 0; i < this.numRows; i++) {
        this.question.indexValues[i].push({ value: "", score: 0 });
      }
      this.numCols = this.numCols + 1;
      this.question.cols.push("");
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      for (let i = 0; i < question.rows.length; i++) {
        if (question.rows[i] == "") {
          errorObj.isValid = false;
          errorObj.msg = "Row label is required.";
          return errorObj;
        } else if (this.stripHtml(question.rows[i]).trim() == "") {
          errorObj.isValid = false;
          errorObj.msg = "Row label cannot be empty.";
          return errorObj;
        } else if (this.stripHtml(question.rows[i]).length > 35) {
          errorObj.isValid = false;
          errorObj.msg = "Row label cannot exceed 35 characters.";
          return errorObj;
        }
      }
      for (let i = 0; i < question.cols.length; i++) {
        if (question.cols[i] == "") {
          errorObj.isValid = false;
          errorObj.msg = "Column label is required.";
          return errorObj;
        } else if (this.stripHtml(question.cols[i]).trim() == "") {
          errorObj.isValid = false;
          errorObj.msg = "Column label cannot be empty.";
          return errorObj;
        } else if (this.stripHtml(question.cols[i]).length > 35) {
          errorObj.isValid = false;
          errorObj.msg = "Column label cannot exceed 35 characters.";
          return errorObj;
        }
      }
      for (let i = 0; i < question.indexValues.length; i++) {
        const x = question.indexValues[i].length;
        for (let j = 0; j < x; j++) {
          if (question.indexValues[i][j].value == "") {
            errorObj.isValid = false;
            errorObj.msg = "Value is required.";
            return errorObj;
          } else if (this.stripHtml(question.indexValues[i][j].value).trim() == "") {
            errorObj.isValid = false;
            errorObj.msg = "Value is required.";
            return errorObj;
          } else if (question.indexValues[i][j].score > 999) {
            errorObj.isValid = false;
            errorObj.msg = "Score cannot be more than 999.";
            return errorObj;
          }
        }
      }
      return { isValid: true };
    }
  }
};
</script>

<style scoped lang="scss">
.col-md-2.rows_label_div {
  position: relative;
  bottom: -34px;
}
.activity_add_edit_index .form-row {
  margin-left: 2px;
}
.add_row {
  width: 115px;
  display: block;
}
.rows_label_div .modal-content {
  width: 800px;
  padding: 35px 20px 0 20px;
  position: absolute;
  top: 2%;
  z-index: 100;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
}
.form-group.col-md-2.p-0.rows_label_div {
  width: 12%;
}
.activity-configurator-step-edit-mode .score_cls {
  margin-left: 0.75%;
}
.activity-configurator-step-edit-mode .btn-success {
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  width: 69px;
  height: 26px;
  padding: 0 0.1px 0 0;
  background-color: #4c8ce4 !important;
  border-color: #4c8ce4 !important;
  line-height: 22px;
}
.form-control {
  border-radius: 0.1rem;
  border: 1px solid #ced4da;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #4c8ce4;
}
.filed_value_box {
  position: relative;
  top: 0px;
}
.row_input,
.column_input {
  position: relative;
}
.row_input .btn.btn-link.color_red,
.column_input .btn.btn-link.color_red {
  position: absolute;
  top: 0;
  right: 0;
}
.row_input .btn.btn-link.color_red img,
.column_input .btn.btn-link.color_red img {
  width: 19px;
  height: 20px;
}
.integer-plus-minus-input {
  width: 2em;
  border: none;
  text-align: center;
}
.col-md-4 .read_only_question .rows_label_div .col-md-2 {
  max-width: 29%;
  flex: 0 0 29.667%;
}
.col-md-4 .form-group.col-md-10.p-0.rows_label_div {
  flex: 0 0 77.333%;
  max-width: 77.333%;
}
.col-md-4 .form-group.col-md-2.p-0.rows_label_div {
  flex: 0 0 22.667%;
  max-width: 26.667%;
}
.add-help-text {
  right: 533px;
  top: -38px;
  padding: 12px 13px;
  &.right-position {
    right: 637px;
  }
}
</style>
